import React from "react";
import {
  PartnerIcon1,
  PartnerIcon2,
  PartnerIcon3,
  PartnerIcon4,
  PartnerIcon5,
} from "../common/Icons";
import Para from "../common/Para";

const PartnerBooking = () => {
  const data = [
    {
      icon: <PartnerIcon1 />,
      title: "All-in-One Booking Convenience",
      desc: "Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. ",
    },
    {
      icon: <PartnerIcon2 />,
      title: "Access to Exclusive Deals",
      desc: "Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. ",
    },
    {
      icon: <PartnerIcon3 />,
      title: "Tailored Travel Experiences",
      desc: "Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. ",
    },
    {
      icon: <PartnerIcon4 />,
      title: "Expertly Curated Packages",
      desc: "Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. ",
    },
    {
      icon: <PartnerIcon5 />,
      title: "Travel with Purpose",
      desc: "Lorem ipsum dolor sit amet consectetur. Elementum nunc duis turpis faucibus vulputate at morbi. Lobortis sociis fermentum nunc volutpat nibh pellentesque imperdiet facilisis. ",
    },
  ];
  return (
    <div className="flex flex-col gap-4 xl:gap-5">
      {data.map((obj, i) => (
        <div className="flex flex-col sm:flex-row gap-3 " key={i}>
          <div>{obj.icon}</div>
          <div className="">
            <h5 className="text-2xl font-medium pb-1">{obj.title}</h5>
            <Para text={obj.desc} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PartnerBooking;
